module.exports = __webpack_public_path__ + "img/2024-ford-mustang.4f16170f.png";